import { App } from '../types';

export const apps: App[] = [
  {
    id: 'anvaya-demo',
    name: 'Anvaya Demo',
    description: 'Document extraction demo with annotation',
    url: 'https://anvaya-demo.mactai.com/',
    requiresLogin: false,
    allowedUsers: ['rajesh@mactai.com', 'madhava@mactai.com']
  },
  {
    id: 'reserve-calculator',
    name: 'Reserve Calculator',
    description: 'Reserve Calculation for Death cases using historical judgements',
    url: 'https://mactai.com/login',
    requiresLogin: true,
    allowedUsers: ['rajesh@mactai.com','madhava@mactai.com'],
    variants: [
      {
        id: 'production',
        name: 'Production',
        description: 'Production environment',
        url: 'https://mactai.com/login'
      },
      {
        id: 'staging',
        name: 'Staging',
        description: 'Staging environment',
        url: 'https://stag.mactai.com/login'
      }
    ],
    credentials: {
      'rajesh@mactai.com': {
        'production': {
          username: 'mrajesh123@gmail.com',
          password: 'BhcfrS58dzXNiRA',
          companyName: 'MACT AI',
          role: 'Admin'
        }
      },
      'madhava@mactai.com': {
        'production': {
          username: 'mrajesh123@gmail.com',
          password: 'BhcfrS58dzXNiRA',
          companyName: 'MACT AI',
          role: 'Admin'
        },
        'staging': {
          username: 'demo@mactai.com',
          password: '123456',
          companyName: 'MACT AI',
          role: 'Admin'
        }
      }
    }
    // OAuth config commented out until implemented
    // oauthConfig: {
    //   clientId: 'reserve-calc-prod',
    //   redirectUri: 'https://mactai.com/oauth/callback',
    //   scope: 'openid profile email'
    // }
  },
  {
    id: 'ecourts-portal',
    name: 'Ecourts Data Portal',
    description: 'Comprehensive legal case data and analytics platform',
    url: 'https://ecourts.mactai.com/login',
    requiresLogin: true,
    allowedUsers: ['rajesh@mactai.com', 'madhava@mactai.com'],
    credentials: {
      'rajesh@mactai.com': {
        username: 'rajesh@mactai.com',
        password: 'xK9#mP2$vL5nQ8@jR3',
        companyName: 'MACT AI',
        role: 'Admin'
      },
      'madhava@mactai.com': {
        username: 'madhava@mactai.com',
        password: 'yW7#nB4$hM9pL2@kT6',
        companyName: 'MACT AI',
        role: 'Admin'
      }
    }
  },
  {
    id: 'mvc-petition',
    name: 'MVC Petition Extraction',
    description: 'MVC Petition Processing Application',
    url: 'https://app.mactai.com/login',
    requiresLogin: true,
    allowedUsers: ['rajesh@mactai.com', 'madhava@mactai.com'],
    variants: [
      {
        id: 'production',
        name: 'Production',
        description: 'Production environment',
        url: 'https://app.mactai.com/login'
      },
      {
        id: 'staging',
        name: 'Staging',
        description: 'Staging environment',
        url: 'https://staging-app.mactai.com/login'
      }
    ],
    credentials: {
      'rajesh@mactai.com': {
        'production': {
          username: 'rajesh@mactai.com',
          password: 'M@ct4I_9xR2p7!Lq',
          companyName: 'MACTAI',
          role: 'admin'
        },
        'staging': {
          username: 'rajesh@mactai.com',
          password: 'M@ct4I_9xR2p7!Lq',
          companyName: 'MACTAI',
          role: 'admin'
        }
      },
      'madhava@mactai.com': {
        'production': {
          username: 'madhava@mactai.com',
          password: 'M@ct4I_8zK3y5#Vb',
          companyName: 'MACTAI',
          role: 'admin'
        },
        'staging': {
          username: 'madhava@mactai.com',
          password: 'M@ct4I_8zK3y5#Vb',
          companyName: 'MACTAI',
          role: 'admin'
        }
      }
    }
    // OAuth config commented out until implemented
    // oauthConfig: {
    //   clientId: 'mvc-petition-prod',
    //   redirectUri: 'https://app.mactai.com/oauth/callback',
    //   scope: 'openid profile email admin'
    // }
  },
  {
    id: 'document-indexing',
    name: 'Document Indexing',
    description: 'Document extraction for MACT and Medical documents',
    url: 'https://indexing.mactai.com',
    requiresLogin: true,
    allowedUsers: ['madhava@mactai.com', 'rajesh@mactai.com'],
    variants: [
      {
        id: 'admin',
        name: 'Admin Access',
        description: 'Full administrative access to all features'
      },
      {
        id: 'tp-user',
        name: 'TP User',
        description: 'Third-party user access'
      },
      {
        id: 'medical-user',
        name: 'Medical User',
        description: 'Medical document processing access'
      }
    ],
    credentials: {
      'madhava@mactai.com': {
        'admin': {
          username: 'madhava@mactai.com',
          password: 'anvaya@123',
          role: 'admin',
          name: 'Madhava'
        },
        'tp-user': {
          username: 'madhava+tp@mactai.com',
          password: 'anvaya@123',
          role: 'tp-user',
          name: 'Madhava TP'
        },
        'medical-user': {
          username: 'madhava+medical@mactai.com',
          password: 'anvaya@123',
          role: 'medical-user',
          name: 'Madhava Medical'
        }
      },
      'rajesh@mactai.com': {
        'admin': {
          username: 'rajesh@mactai.com',
          password: 'anvaya@123',
          role: 'admin',
          name: 'Rajesh'
        }
      }
    }
    // OAuth config commented out until implemented
    // oauthConfig: {
    //   clientId: 'document-indexing',
    //   redirectUri: 'https://indexing.mactai.com/oauth/callback',
    //   scope: 'openid profile email admin'
    // }
  }
];